import React from 'react'

import AbsolutePageTemplate from '../../../../components/templates/AbsolutePageTemplate'
import ServiceOrdersLoader from '../_load/ServiceOrderLoader'
import PageHeader from '../_shared/PageHeader'
import PageContent from './PageContent'

const TemplateInternoContratoV2PdfPage = ({ id, templateId }) => {
  return (
    <AbsolutePageTemplate>
      <ServiceOrdersLoader id={id}>
        <PageHeader templateId={parseInt(templateId)} />
        <PageContent templateId={parseInt(templateId)} />
      </ServiceOrdersLoader>
    </AbsolutePageTemplate>
  )
}

export default TemplateInternoContratoV2PdfPage
